type AccountExistsPayload =
  | null
  | undefined
  | boolean
  | {
      exists?: boolean;
      accountExists?: boolean;
      data?:
        | boolean
        | {
            exists?: boolean;
            accountExists?: boolean;
          };
    };

export type AccountExistsCheck = {
  email: string;
  emailKey: string;
  exists: boolean;
};

export const ACCOUNT_EXISTS_ENDPOINT =
  "https://core.builtwithscience.com/internal/public/account/exists";

export function getAccountExistsEmailKey(email: string): string {
  return email.trim().toLowerCase();
}

export function getAccountExistsCheckForEmail(
  check: AccountExistsCheck | null,
  email: string | null | undefined
): AccountExistsCheck | null {
  if (!check || !email) {
    return null;
  }

  return check.emailKey === getAccountExistsEmailKey(email) ? check : null;
}

export function parseAccountExistsResponse(payload: AccountExistsPayload): boolean {
  if (payload == null) {
    return false;
  }

  if (typeof payload === "boolean") {
    return payload;
  }

  if (typeof payload.data === "boolean") {
    return payload.data;
  }

  const data = payload.data;

  return Boolean(
    payload.exists ??
      payload.accountExists ??
      data?.exists ??
      data?.accountExists
  );
}

export async function accountExists(email: string): Promise<boolean> {
  try {
    const response = await fetch(ACCOUNT_EXISTS_ENDPOINT, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
      },
      body: JSON.stringify({ email: email.trim() }),
    });

    if (!response.ok) {
      console.warn(
        `Account exists check failed with status ${response.status}`
      );
      return false;
    }

    const payload = (await response.json()) as AccountExistsPayload;
    return parseAccountExistsResponse(payload);
  } catch (error) {
    console.warn("Account exists check unavailable:", error);
    return false;
  }
}
